import { DefaultKeys, QueryKeys } from "@Totum/QuestionnaireBuilder/Constants";
import { getQuestionnaire, getQuestionnaires } from "@Totum/QuestionnaireBuilder/Services/apiService";
import { useQuery } from "@tanstack/react-query";
import { ThreeMinutes } from "@Totum/Main/Constants";

/**
 * Hook to fetch all questionnaires.
 */
export const useQuestionnairesQuery = () =>
    useQuery([QueryKeys.QuestionnaireList], getQuestionnaires, {
        staleTime: ThreeMinutes,
        refetchOnWindowFocus: false,
    });

export const useQuestionnaireQuery = (questionnaireId?: string) =>
    useQuery(
        [QueryKeys.QuestionnaireCurrent, questionnaireId],
        () => {
            if (!questionnaireId) {
                return null;
            }
            return getQuestionnaire(questionnaireId);
        },
        {
            enabled: !!questionnaireId && questionnaireId !== String(DefaultKeys.NEW_QUESTIONNAIRE_ID),
            staleTime: ThreeMinutes,
            refetchOnWindowFocus: false,
        }
    );
